import { createAction } from '@reduxjs/toolkit'

import type { SortItem } from './index'

export const changeSortModel = (sliceName: string) =>
  createAction<SortItem>(`${sliceName}/changeSortModel`)
